import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MessageCircle, Phone, Mail, Clock, MapPin } from 'lucide-react';
import { contactInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo e Descrição */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_web-clone-project-10/artifacts/h37p4abd_image.png" 
                alt="OpaLink Telecom" 
                className="h-14 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Internet via fibra óptica com qualidade e velocidade para sua casa e empresa.
            </p>
            <div className="flex space-x-3">
              <a
                href={contactInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2.5 rounded-full hover:bg-orange-500 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2.5 rounded-full hover:bg-orange-500 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={contactInfo.social.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2.5 rounded-full hover:bg-orange-500 transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-500 transition-colors text-sm flex items-center">
                  <span className="mr-2">›</span> Início
                </Link>
              </li>
              <li>
                <Link to="/sobre-nos" className="text-gray-400 hover:text-orange-500 transition-colors text-sm flex items-center">
                  <span className="mr-2">›</span> Sobre nós
                </Link>
              </li>
              <li>
                <Link to="/para-voce" className="text-gray-400 hover:text-orange-500 transition-colors text-sm flex items-center">
                  <span className="mr-2">›</span> Para você
                </Link>
              </li>
              <li>
                <Link to="/para-sua-empresa" className="text-gray-400 hover:text-orange-500 transition-colors text-sm flex items-center">
                  <span className="mr-2">›</span> Para sua empresa
                </Link>
              </li>
              <li>
                <Link to="/atendimento" className="text-gray-400 hover:text-orange-500 transition-colors text-sm flex items-center">
                  <span className="mr-2">›</span> Atendimento
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-400 text-sm">
                <Phone size={16} className="mr-2 mt-1 flex-shrink-0 text-orange-500" />
                <div>
                  <p className="font-semibold text-white">Central de Atendimento</p>
                  <p>0800 235-0099</p>
                  <p className="text-xs mt-1">WhatsApp: (88) 99610-5011</p>
                </div>
              </li>
              <li className="flex items-start text-gray-400 text-sm">
                <MapPin size={16} className="mr-2 mt-1 flex-shrink-0 text-orange-500" />
                <span>Ceará, Brasil</span>
              </li>
              <li className="flex items-start text-gray-400 text-sm">
                <Clock size={16} className="mr-2 mt-1 flex-shrink-0 text-orange-500" />
                <div>
                  <p className="font-semibold text-white">Horário de Atendimento</p>
                  <p>Segunda à Sexta: 07:30 - 17:00</p>
                  <p>Sábado: 08:00 - 12:00</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Acesso Rápido */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Acesso Rápido</h3>
            <div className="space-y-2">
              <a
                href={contactInfo.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg transition-colors text-sm font-medium text-center"
              >
                <MessageCircle size={16} className="inline mr-2" />
                Fale conosco
              </a>
              <a
                href={contactInfo.clientAreaLink}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-orange-600 hover:bg-orange-700 text-white px-4 py-2.5 rounded-lg transition-colors text-sm font-medium text-center"
              >
                2ª Via da fatura
              </a>
              <a
                href={contactInfo.clientAreaLink}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-blue-600 hover:bg-blue-700 text-white px-4 py-2.5 rounded-lg transition-colors text-sm font-medium text-center"
              >
                Área do cliente
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="text-center text-gray-400 text-sm">
            <p>&copy; {new Date().getFullYear()} OpaLink Telecom. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
